module.exports = __webpack_public_path__ + "static/media/Gleam-Giveaway-Baby.2a408b57.png";